import React from 'react'

import Contact from './Contact/Contact'
import Content from './Content/Content'
import Footer from './Footer/Footer'
import Nav from './Nav/Nav'
import Section from './Section/Section'
import { Wrapper } from './styles/LandingPage.styled'
import Subscribe from './Subscription/Subscribe'
import GlobalStyle from './globalStyles';

const LandingPage = () => {

  return (
    <Wrapper>
      <GlobalStyle />
        <Nav />
        <Content />
        <Section />
        <Subscribe />
        <Contact />
        <Footer />
    </Wrapper>
  )
}

export default LandingPage